import React from 'react';

const FacebookIcon = ({ width = 40, height = 40 }) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    className="fill-current text-techsicoGray-200 hover:text-white hover:shadow-2xl"
  >
    <path
      d="M43.36.749H20.026a8.333,8.333,0,0,0-8.333,8.333V32.416a8.335,8.335,0,0,0,8.333,8.333H43.36a8.334,8.334,0,0,0,8.333-8.333V9.082A8.332,8.332,0,0,0,43.36.749Zm-5,11.667h-3.2c-1.027,0-1.8.42-1.8,1.48v1.853h5l-.4,5h-4.6V34.082h-5V20.749H25.026v-5H28.36V12.542c0-3.368,1.773-5.127,5.768-5.127H38.36Z"
      transform="translate(-11.693 -0.749)"
    />
  </svg>
);

export default FacebookIcon;
